import { locations } from "../../common/redux/action_locations";
import {
	FETCH_TIMEOFF_TYPE,
    TIMEOFF_TYPE_RECEIVED,
    FETCH_UNAVAILABLE_TIMEOFF_DATES,
    UNAVAILABLE_TIMEOFF_DATES_RECIEVED,
    FETCH_PTO_BALANCE,
    PTO_BALANCE_RECIEVED,
    POST_REQUEST_TIMEOFF,
    REQUEST_TIMEOFF_COMPLETED,
    FETCH_REQUEST,
    REQUEST_RECIEVED,
    PUT_REQUEST_TIMEOFF,
    CANCEL_REQUEST_TIMEOFF
} from "./constants";
import moment from "moment-timezone";
import { CFAuthGetRef, CFAuthPostRef, CFAuthPutRef } from "auth";


function fetchTimeOffType() {
    return CFAuthGetRef({
        url:
            process.env.REACT_APP_AP_API_URL +
            `/Enum/TimeoffType`,                    
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchTimeOffType"
    });
}

function fetchUnavailableDates(filters) {
    return CFAuthGetRef({
        url:
            process.env.REACT_APP_AP_API_URL + 
            `/TimeoffRequest/Availability/${filters.managementUnitID}`,     
        params: { 
            blockedDates: true, 
            agentID: filters.agentID ? filters.agentID : null
        },             
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchUnavailableDates"
    });
}

function fetchPTOBalance(filters) {
    return CFAuthGetRef({
        url:
            process.env.REACT_APP_AP_API_URL+
            `/TimeoffRequest/Accrued/Projection/${filters.agentID}`, 
        params: { TargetDate: filters.requestStartDate, TimeOffId: filters.timeOffId },           
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchPTOBalance"
    });
}

function requestTimeOff(body){
    return CFAuthPostRef({
        url: process.env.REACT_APP_AP_API_URL + '/TimeoffRequest',
        body,
        originURL: locations.originUrl,
        loaderName: 'requestTimeOff'
    });
}

function requestTimeOffUpdate(body){   
    return CFAuthPutRef({
        url: process.env.REACT_APP_AP_API_URL + '/TimeoffRequest',
        body,
        originURL: locations.originUrl,
        loaderName: 'requestTimeOffUpdate'
    });
}
function requestTimeOffCancel(filters){
    return CFAuthGetRef({
        url:
            process.env.REACT_APP_AP_API_URL+
            `/TimeoffRequest/Cancel/${filters.requestID}`,         
        originURL: process.env.PUBLIC_URL,
        loaderName: "requestTimeOffCancel"
    });
}

function fetchRequestByID(filters) {
    return CFAuthGetRef({
        url:
            process.env.REACT_APP_AP_API_URL+
            `/TimeoffRequest/${filters.requestID}`,         
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchRequestByID"
    });
}

export function fetchTimeOffTypeAction() {
	return {
        type: FETCH_TIMEOFF_TYPE,
        fetchCall: fetchTimeOffType,
        receivedAction: recievedTimeOffType,
        data: {
            locations
        }
    };
}

export function fetchUnavailabledDatesAction(filters) {
	return {
        type: FETCH_UNAVAILABLE_TIMEOFF_DATES,
        fetchCall: fetchUnavailableDates,
        receivedAction: recievedUnavailableDates,
        data: {
            filters,
            locations
        }
    };
}

export function fetchPTOBalanceAction(filters) {
	return {
        type: FETCH_PTO_BALANCE,
        fetchCall: fetchPTOBalance,
        receivedAction: recievePTOBalance,
        data: {
            filters,
            locations
        }
    };
}


export function requestTimeOffAction(body){
    return{
        type: POST_REQUEST_TIMEOFF,
        data: {body},
        locations: locations,
        fetchCall: requestTimeOff,
        receivedAction: handleRequestTimeOffResponseAction
    }
}
export function requestTimeOfUpdateAction(body){
    return{
        type: PUT_REQUEST_TIMEOFF,
        data: {body},
        locations: locations,
        fetchCall: requestTimeOffUpdate,
        receivedAction: handleRequestTimeOffResponseAction
    }
}

export function fetchRequestByIDAction(filters) {
	return {
        type: FETCH_REQUEST,
        fetchCall: fetchRequestByID,
        receivedAction: recievedRequestByID,
        data: {
            filters,
            locations
        }
    };
}


export function requestTimeOffCancelAction(filters) {
	return {
        type: CANCEL_REQUEST_TIMEOFF,
        fetchCall: requestTimeOffCancel,
        receivedAction: handleRequestTimeOffResponseAction,
        data: {
            filters,
            locations
        }
    };
}

function recievedTimeOffType(data){
    var timeOffType = []
    if(data && data.length > 0){
        data.forEach(option => {
            timeOffType.push({
                label: option.value,
                value: option.key
            })
        })
    }    
    return{
        type: TIMEOFF_TYPE_RECEIVED,
        timeOffType: timeOffType
    }
} 

function recievedUnavailableDates(data = []){ 
    var unavailableDates= []
    var agentTimeOffs = []
    data.forEach(date => {
        unavailableDates.push(moment(date.key));
        if(date.value.takenHours === 1 && date.value.approvedHours === 0)
            agentTimeOffs.push(moment(date.key))
    })   
    return{
        type:UNAVAILABLE_TIMEOFF_DATES_RECIEVED,
        unavailableDates: unavailableDates,
        agentTimeOffs: agentTimeOffs
    }
} 

function recievePTOBalance(data){
   
    return{
        type:PTO_BALANCE_RECIEVED,
        accuredProjections: data
    }
} 

function handleRequestTimeOffResponseAction(res){    
    return {
        type: REQUEST_TIMEOFF_COMPLETED,
        response: {
            error: !res.ok,
            responseText: res.message ? res.message : ""
        }
    }
}

function recievedRequestByID(data){
   
    return{
        type:REQUEST_RECIEVED,
        timeOffRequest: data[0]
    }

} 

export function reducer(state, action) {
    switch (action.type) {
        case TIMEOFF_TYPE_RECEIVED:
            return {
                ...state,
                timeoffType: action.timeOffType
            };
        case UNAVAILABLE_TIMEOFF_DATES_RECIEVED:
            return {
                ...state,
                unavailableDates: action.unavailableDates,
                agentTimeOffsRequested: action.agentTimeOffs
            }; 
        case PTO_BALANCE_RECIEVED:
            return {
                ...state,
                accuredProjections: action.accuredProjections
            }; 

        case REQUEST_TIMEOFF_COMPLETED:
            return {
                ...state,
                timeOffResponse: action.response
            }; 
        case REQUEST_RECIEVED:
            return {
                ...state,
                timeOffRequest: action.timeOffRequest
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/timeoff/redux/timeoff_request_modal_actions.js